module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-SemiBold.44d0a87e.woff2";